import React from 'react';
import { FadeIn, CTAButton, Section } from './Shared';
import { ShieldCheck, Lock, CreditCard, Star, XCircle } from 'lucide-react';
export const Hero = () => {
  return <section className="bg-bg-base px-4 pt-4 pb-7 md:pt-16 md:pb-16 overflow-hidden" data-id="element-303" data-mp="mz5vbfm4mugs">
      <div className="max-w-[700px] mx-auto text-center space-y-2.5 md:space-y-6" data-id="element-304" data-mp="rubpf1ponffy">
        <FadeIn data-id="element-305" data-mp="wqsato5hzfpc">
          <div className="space-y-2 md:space-y-4" data-id="element-306" data-mp="wteo84f2kpfh">
            <div className="inline-flex items-center gap-1.5 bg-bg-card text-brandGold font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[11px] px-3 py-1 md:px-4 md:py-1.5 rounded-full border border-brandGold/40" data-id="element-307" data-mp="3va0ptrn0py7b">
              <span className="text-sm md:text-base" data-id="element-308" data-mp="90fz0274syth">🎨</span>
              <span className="text-[8.5px]" data-id="element-309" data-mp="e13x17ts2fx7">
                MEGAPACK COLORIMETRÍA LISTA™
              </span>
            </div>
            <h1 className="font-hero font-bold uppercase text-[30px] md:text-[56px] leading-[1.08] tracking-[0.5px] text-txt-primary mx-auto max-w-[20ch] px-2 pt-3 pb-1" data-id="element-310" data-mp="1kgeaecps7wxv">
              <span className="block" data-id="element-311" data-mp="1h999bi4t88vl">DOMINÁ LOS</span>
              <span className="block text-brandGold" data-id="element-312" data-mp="1h7y55h7gcz3y">PLATINADOS Y BLANCOS.</span>
              <span className="block" data-id="element-313" data-mp="1cc0sbkveeavx">SIN MIEDO A LOS REFLEJOS AMARILLOS.</span>
            </h1>

            <p className="text-txt-body text-[12.5px] md:text-[16px] leading-[1.4] md:leading-[1.7] font-sans px-3" data-id="element-314" data-mp="187t03dpqecsy">El método exacto con videos y manuales
para lograr colores perfectos, cobrar más caro y dejar de improvisar con tus
clientes.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.15} data-id="element-315" data-mp="tj6mphjnzv4d">
          <a href="#pricing" className="block cursor-pointer relative" data-id="element-316" data-mp="tiwv5piz1fwk">
            <div className="absolute inset-0 bg-brandGold/15 blur-[40px] rounded-full" data-id="element-317" data-mp="olwn592ka32t"></div>
            <div className="absolute inset-y-0 -inset-x-10 bg-brandGold/10 blur-[28px] rounded-full" data-id="element-318" data-mp="klmibzqi9ipj"></div>
            <img src="https://cdn.magicpatterns.com/uploads/agacHF4oUprc8XhkQK75E2/mockup_sticker.png" alt="Megapack Colorimetría Lista — Mockup completo del producto" loading="eager" decoding="async" width={1000} height={1000}
          // @ts-ignore — supported by modern browsers
          fetchpriority="high" className="relative block w-full max-w-[300px] md:max-w-[560px] mx-auto h-auto object-contain hover:-translate-y-1 transition-transform duration-300 drop-shadow-2xl" data-id="element-319" data-mp="fk6u5yt16w2x" />
          </a>
        </FadeIn>

        <FadeIn delay={0.25} data-id="element-320" data-mp="3s6nfrjiw52gr">
          <div className="max-w-2xl mx-auto space-y-2.5 md:space-y-5" data-id="element-321" data-mp="jo7oyxaaaxds">
            {/* Chips - same on all screens */}
            <div className="flex flex-wrap gap-1.5 md:gap-2 justify-center items-center" data-id="element-322" data-mp="omspyyxd1l3a">
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[10.5px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-323" data-mp="9zpu0woorki2">
                <span className="text-[10px] md:text-xs" data-id="element-324" data-mp="12ndco66ec122">📄</span> 100% PDF +
                Videos HD
              </span>
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[10.5px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-325" data-mp="17fwnivdp8i36">
                <span className="text-[10px] md:text-xs" data-id="element-326" data-mp="2n54iywh3lswl">⚡</span> Acceso en 5
                min
              </span>
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[10.5px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-327" data-mp="31wmv2j6u73ao">
                <span className="text-[10px] md:text-xs" data-id="element-328" data-mp="297prlm7abb1z">📚</span> 475+ páginas
                + 14 h de video
              </span>
            </div>

            {/* CTA button + trust */}
            <div className="space-y-2 md:space-y-3" data-id="element-329" data-mp="2i4gjdmet03qr">
              <CTAButton href="#pricing" fullWidth className="!py-3.5 md:!py-4 !text-[14px] md:!text-base" data-id="element-330" data-mp="2e4pvprkkq3qg">
                🎨 QUIERO EL MEGAPACK AHORA
              </CTAButton>

              <div className="flex flex-wrap items-center justify-center gap-2 md:gap-4 text-[9.5px] md:text-xs text-txt-muted font-sans" data-id="element-331" data-mp="3pkej2k1qp4rs">
                <span className="flex items-center gap-1" data-id="element-332" data-mp="oq8ec09n1mnp">
                  <ShieldCheck size={11} className="text-success" data-id="element-333" data-mp="sq8y80fiaq25" /> Garantía 7
                  días
                </span>
                <span className="flex items-center gap-1" data-id="element-334" data-mp="xok2zwqy2adi">
                  <Lock size={11} className="text-txt-muted" data-id="element-335" data-mp="12ooo602srta2" /> Pago seguro
                </span>
                <span className="flex items-center gap-1" data-id="element-336" data-mp="17nriaph8of39">
                  <CreditCard size={11} className="text-brandGold" data-id="element-337" data-mp="17n9mtv2ei4we" /> Pagas en
                  tu moneda local
                </span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};
export const SocialProof = () => {
  const stats = [{
    value: '+500',
    label: 'barberos lo recomiendan'
  }, {
    value: '15',
    label: 'Módulos en video'
  }, {
    value: '4',
    label: 'Manuales PDF'
  }, {
    value: '4.9/5',
    label: 'calificación',
    star: true
  }];
  return <div className="bg-bg-alt border-y border-line py-6" data-id="element-338" data-mp="1vb9fj0j9w5dm">
      <div className="max-w-[1100px] mx-auto px-6" data-id="element-339" data-mp="3fwfrk31rdtww">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center divide-x divide-line" data-id="element-340" data-mp="3awbc8gcl7589">
          {stats.map((stat, i) => <FadeIn key={stat.label} delay={0.1 + i * 0.1} data-id="element-341" data-mp="35wp06a8hvv11" data-mpi={i}>
              <div className="font-display font-bold text-[30px] md:text-[42px] leading-[1.1] text-brandGold mb-0.5" data-id="element-342" data-mp="35zb7q9vdyaj9">
                {stat.value}
              </div>
              <div className="text-sm font-sans text-txt-body flex items-center justify-center gap-1" data-id="element-343" data-mp="2f6t450jqs1o">
                {stat.label}
                {stat.star && <Star size={12} className="fill-gold text-gold" data-id="element-344" data-mp="3ow2y139chpwt" />}
              </div>
            </FadeIn>)}
        </div>
      </div>
    </div>;
};
export const Testimonials1 = () => {
  const testimonials = [{
    initials: 'JM',
    text: 'No sabía como realizar platinados. Con esto aprendí como hacerlos. Me ayudo mucho, gracias.',
    author: 'Juan M.',
    role: 'Barbero Profesional · Argentina',
    bg: 'bg-brandGold text-[#14100A]'
  }, {
    initials: 'CS',
    text: 'Implemente el servicio de color. Ahora realizo trabajos completos y sin dudas, muy recomendable.',
    author: 'Carlos S.',
    role: 'Dueño de Barbería · México',
    bg: 'bg-brandSteel-deep text-white'
  }, {
    initials: 'RF',
    text: 'Descargué todo el curso. Me llego inmediatamente y me ayudo mucho a comprender qué fórmula usar.',
    author: 'Roberto F.',
    role: 'Colorista · Colombia',
    bg: 'bg-brandGold text-[#14100A]'
  }];
  return <Section className="bg-bg-base" data-id="element-345" data-mp="1vzqmsnhb8bgr">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-2.5 md:gap-4" data-id="element-346" data-mp="1w0s6thgb08am">
        {testimonials.map((t, i) => <FadeIn key={i} delay={Math.min(i * 0.05, 0.2)} data-id="element-347" data-mp="1i1ae4qzw0avz" data-mpi={i}>
            <div className="bg-bg-card p-3.5 md:p-5 rounded-[14px] md:rounded-[18px] border border-line h-full flex flex-col" data-id="element-348" data-mp="1mxr1vk36cn8j">
              <div className="flex items-center gap-2.5 mb-2.5" data-id="element-349" data-mp="3ce08f9u63m3w">
                <div className={`w-8 h-8 md:w-9 md:h-9 ${t.bg} rounded-full flex items-center justify-center font-sans font-bold text-[11px] md:text-xs shrink-0`} data-id="element-350" data-mp="3hd3duve27uce">
                  {t.initials}
                </div>
                <div className="min-w-0" data-id="element-351" data-mp="10r6g5mqnx0ib">
                  <div className="flex text-gold mb-0.5" data-id="element-352" data-mp="10o0uyil5mirv">
                    {[...Array(5)].map((_, j) => <Star key={j} size={10} className="fill-current" data-id="element-353" data-mp="1fgchbg9290su" data-mpi={j} />)}
                  </div>
                  <p className="font-sans font-bold text-txt-primary text-[12px] md:text-[13px] leading-tight" data-id="element-354" data-mp="1an04029u0gfe">
                    {t.author}
                  </p>
                  <p className="text-[10px] md:text-[11px] font-sans text-txt-muted" data-id="element-355" data-mp="1jfl7kb4w6gjn">
                    {t.role}
                  </p>
                </div>
              </div>
              <p className="text-txt-body font-sans text-[12.5px] md:text-[13.5px] leading-[1.5] italic" data-id="element-356" data-mp="1tf2e0urywygo">
                "{t.text}"
              </p>
              <p className="font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[10px] text-brandGold mt-auto pt-2.5" data-id="element-357" data-mp="404klvgb8jp3">
                Compró el Megapack
              </p>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
};
export const Problem = () => {
  const painPoints = ['Alguna vez utilizaste fórmulas o técnicas con información que encontraste por tu cuenta', 'Tienes dudas sobre la preparación exacta que necesitas para decolorar el cabello sin lastimarlo', 'Tus trabajos no siempre se ven iguales porque no tienes la fórmula exacta para cada color', 'Un cliente nuevo pide un "blanco" y se te complica por los reflejos amarillos', 'Cada color te lleva mucho tiempo y no te rinde por cobrar a un precio que no es rentable', 'Conocés sobre el tema, pero no estás conforme con el resultado final y el ciclo se repite'];
  return <Section className="bg-bg-alt" data-id="element-358" data-mp="34ef04z0xrh82">
      <div className="max-w-[720px] mx-auto" data-id="element-359" data-mp="34fgkju3udg2g">
        <FadeIn data-id="element-360" data-mp="fmcqutqxrjxw">
          <h2 className="font-display font-bold uppercase md:text-[36px] text-center mb-8 text-txt-primary text-[22px] leading-[1.25] tracking-[0.5px]" data-id="element-361" data-mp="fmuljlxy9q3p">
            Si realizas trabajos de <span className="text-brandGold" data-id="element-362" data-mp="245gyphxp6stj">colorimetría,</span>
            <br data-id="element-363" data-mp="244xd9r8u9mar" />
            esto te va a sonar familiar...
          </h2>

          <div className="space-y-2 md:space-y-3 mb-10" data-id="element-364" data-mp="205et4xoudf8z">
            {painPoints.map((point, i) => <div key={i} className="flex items-start gap-2.5 bg-bg-card border border-line rounded-[10px] py-2.5 px-3 md:py-3 md:px-4" data-id="element-365" data-mp="1vcdcol8zl7na" data-mpi={i}>
                <XCircle className="text-danger shrink-0 mt-0.5" size={16} data-id="element-366" data-mp="1qc7tltgs8tgt" />
                <p className="text-txt-body font-sans text-[13px] md:text-[15px] leading-[1.5]" data-id="element-367" data-mp="1lgsgj3qln1lg">
                  {point}
                </p>
              </div>)}
          </div>

          {/* Gold divider */}
          <div className="h-[2px] w-32 md:w-48 mx-auto rounded-full mb-10 md:mb-12 bg-brandGold" style={{
          boxShadow: '0 0 12px rgba(212,162,76,0.7), 0 0 24px rgba(212,162,76,0.4)'
        }} data-id="element-368" data-mp="1cesz4abo9vhz"></div>

          <h3 className="font-display font-bold uppercase md:text-[40px] text-center text-txt-primary mb-8 relative text-[24px] leading-[1.2] tracking-[0.5px]" data-id="element-369" data-mp="36qhh6ld7ae6l">
            ¿Sigues improvisando{' '}
            <span className="text-brandGold inline-block" style={{
            textShadow: '0 0 20px rgba(212,162,76,0.5), 0 0 40px rgba(212,162,76,0.3)'
          }} data-id="element-370" data-mp="idras1s1qbhw">
             por no tenér la información correcta?
            </span>
          </h3>

          <div className="space-y-4 text-txt-body font-sans text-[15px] md:text-base leading-[1.7] mb-10" data-id="element-371" data-mp="md05b8uwudei">
            <p style={{
            paddingLeft: "10px"
          }} data-id="element-372" data-mp="3uu38zhuk3cnf">
              Elegiste este camino porque amás esta profesión, trabajar en la imagen de las personas y ganar dinero en serio.
            </p>
            <p style={{
            paddingLeft: "9px"
          }} data-id="element-373" data-mp="8e8srqvp4zsh">
              Pero nadie te dijo que ibas a perder tiempo y dinero, improvisando con tus clientes, intentando descubir EL SECRETO EXACTO que utilizan los barbéros: dónde TODO esté organizado, donde NO FALLES y
              puedas COBRAR lo que realmente vale tu trabajo.
            </p>
          </div>

          {/* Highlighted closing question */}
          <div className="relative bg-bg-card border-2 border-brandGold rounded-[16px] py-5 px-5 md:py-6 md:px-8 shadow-[0_0_40px_rgba(212,162,76,0.2)]" data-id="element-374" data-mp="1mk54rnyhd5rd">
            <p className="font-display font-bold text-[18px] md:text-[26px] leading-[1.3] text-center text-txt-primary uppercase tracking-[0.5px]" data-id="element-375" data-mp="1dljibhpw16lb">
              ¿Y SI HOY TUVIERAS TODO LISTO PARA{' '}
              <span className="text-brandGold" data-id="element-376" data-mp="2695sj8tmf9h5">DOMINAR LA TÉCNICA?</span>
            </p>
          </div>

          {/* Gold divider — transition to product */}
          <div className="h-[2px] w-32 md:w-48 mx-auto rounded-full mt-10 md:mt-14 bg-brandGold" style={{
          boxShadow: '0 0 12px rgba(212,162,76,0.7), 0 0 24px rgba(212,162,76,0.4)'
        }} data-id="element-377" data-mp="2a8od23hj5ijg"></div>
        </FadeIn>
      </div>
    </Section>;
};